import { useController } from 'react-hook-form';
import type { ColumnSizingState, OnChangeFn, Updater } from '@tanstack/react-table';
import { useCallback } from 'react';

export const useSizingState = (): [ColumnSizingState, OnChangeFn<ColumnSizingState>] => {
  const { field } = useController({ name: 'sizing' });

  const onSizingChange: OnChangeFn<ColumnSizingState> = useCallback(
    (updaterOrValue: Updater<ColumnSizingState>) => {
      const nextState = typeof updaterOrValue === 'function' ? updaterOrValue(field.value) : updaterOrValue;

      field.onChange(nextState);
    },
    [field],
  );

  return [field.value, onSizingChange];
};
